import logoBrand from '@/assets/images/logo-brand-header.svg'
import { Button } from '@/components/atoms/Button/Button'
import { Logo } from '@/components/molecules/Logo/Logo'
import { useModal } from '@/hooks/useModal'
import { motion } from 'framer-motion'
import { Menu } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { MenuMobile } from '../MenuMobile/MenuMobile'
import { Modal } from '../Modal/Modal'

interface HeaderProps {
  isError?: boolean
  isNotHome?: boolean
}

const Header: React.FC<HeaderProps> = ({ isError = false, isNotHome = false }) => {
  // const { t } = useTranslation()
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const navigate = useNavigate()

  // Detectar cuando el usuario hace scroll
  useEffect(() => {
    const handleScroll = (): void => {
      // Cambia el estado cuando el scroll supera los 100px (ajusta según la altura de tu banner)
      if (window.scrollY > 200) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Función para manejar el scroll al hacer clic en los enlaces
  const handleScroll = (sectionId: string): void => {
    if (isError) {
      navigate('/')
    } else if (isNotHome) {
      navigate('/')
      setTimeout(() => {
        const section = document.getElementById(sectionId)
        if (section != null) {
          section.scrollIntoView({ behavior: 'smooth' })
        }
      }, 200)
    } else {
      // De lo contrario, desplázate a la sección correspondiente
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <>
      <motion.header
        className={`p-4 fixed w-full z-[10] transition-all duration-500 ease-in-out ${isError
          ? 'bg-primary py-4'
          : isScrolled && !isHovered
            ? 'backdrop-blur-md py-2'
            : 'bg-transparent py-4'

          }`}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          background: isError
            ? '#187D38'
            : isScrolled
              ? 'linear-gradient(135deg, rgba(2, 14, 40, 0.7) 0%, rgba(4, 5, 5, 0.7) 100%)'
              : 'transparent',
          transition: 'background 0.5s ease-in-out, backdrop-filter 0.5s ease-in-out, padding 0.5s ease-in-out'
        }}
      >
        <div className='w-full container lg:max-w-[1380px] mx-auto px-0 flex justify-between lg:justify-center items-center lg:gap-[7rem]'>
          <Link to='/' className='transition-transform duration-500 ease-in-out' style={{ transform: isScrolled ? 'scale(0.75)' : 'scale(1)' }}>
            <Logo src={logoBrand} alt='Lumar Prestige Logo' width={255} height={71} />
          </Link>
          <div className='hidden lg:flex gap-2 items-center'>
            <nav className='flex items-center gap-4'>
              <ul className='flex items-center gap-8'>
                <li>
                  <button onClick={() => handleScroll('home')} className='text-white hover:opacity-80 font-light text-[16px]'>
                    Home
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('aboutUs')} className='text-white hover:opacity-80 font-light text-[16px]'>
                    About us
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('services')} className='text-white hover:opacity-80 font-light text-[16px]'>
                    Services
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('formContactUs')} className='text-white hover:opacity-80 font-light text-[16px]'>
                    Benefits
                  </button>
                </li>
                <div className='gap-4 items-center hidden lg:flex'>
                  {/* <ButtonContactUsModal /> */}
                  <Button
                    className='bg-primary text-white font-bold hover:bg-primary-500'
                    onClick={() => handleScroll('formContactUs')}
                  >
                    Contact
                  </Button>
                </div>
              </ul>
            </nav>
          </div>
          <div className='flex lg:hidden' onClick={openModal}>
            <Menu size={24} color='#ffffff' />
          </div>
          <div className='gap-4 items-center flex lg:hidden'>
            {/* <ButtonContactUsModal /> */}
            <Button
              className='bg-primary text-white font-bold hover:bg-primary-500'
              onClick={() => handleScroll('formContactUs')}
            >
              Contact
            </Button>
          </div>
        </div>
      </motion.header>
      <Modal isOpenModal={isOpenModal} closeModal={closeModal}>
        <MenuMobile closeModal={closeModal} isNotHome={isNotHome} />
      </Modal>
    </>
  )
}

export default Header
